var footerController = {
    isFooterAppLoaded: false,
    isFooterScanLoaded: false,
    LOCALISATION: "localisation",
    TEMOINS: "temoins",
    FONTIONS: "fonctions",
    AUDIO_NAV: "audio_nav",
    SCAN: "scan",
    currentMenu: "localisation"
};

footerController.init = function() {
    footerController.isFooterAppLoaded = false;
    footerController.isFooterScanLoaded = false;

    var currentMenuPpreferences = preferences.getItemVehicle("lastMenu");

    if ( currentMenuPpreferences != null && currentMenuPpreferences != undefined ) {
        footerController.currentMenu = currentMenuPpreferences;
    }
}

footerController.loadFooterApp = function($newcontent) {
    if ( !footerController.isFooterAppLoaded ) {
        footerController.isFooterAppLoaded = true;
        footerController.isFooterScanLoaded = false;

        if ( $newcontent === undefined ) {
            $newcontent = $("#app-content");
        }

        $.ajax({
            type: "GET",
            url: loadContent.racineTemplates + "doc/templates/template_footer.mustache",
            dataType: "text",
            async: true
        }).done(function (data) {
            $("#footer").empty();

            var htmlText = Mustache.render(data, []);
            var $content = $(htmlText);
            $($content).find("[data-i18n]").i18n();

            $($newcontent).find("#footer").append($content);
            footerController.selectItem();
        });
    }
}

footerController.loadFooterScan = function() {
    if ( footerController.isFooterScanLoaded == false ) {
        footerController.isFooterAppLoaded = false;
        footerController.isFooterScanLoaded = true;

        $.ajax({
            type: "GET",
            url: loadContent.racineTemplates + "doc/templates/template_footer_scan.mustache",
            dataType: "text",
            async: true
        }).done(function (data) {
            $("#app-content").find("#footer").empty();

            var htmlText = Mustache.render(data, []);
            var $content = $(htmlText);
            $($content).find("[data-i18n]").i18n();

            $("#app-content").find("#footer").append($content);
        });
    }
}

footerController.selectItem = function() {
    var $newcontent = $("#app-content").find("#content");

    var $elementCategory = $($newcontent).find("[data-category-screen]");
    var $elementType = $($newcontent).find("[data-type-screen]");

    if ( $elementCategory.length > 0 && $elementType.length > 0 ) {
        var categoryScreen = $($elementCategory).attr("data-category-screen");
        var typeScreen = $($elementType).attr("data-type-screen");

        if ( categoryScreen.toLowerCase() == "home" || categoryScreen.toLowerCase() == "menu" ) {
            switch (typeScreen.toLowerCase()) {
              case footerController.LOCALISATION:
                footerController.currentMenu = footerController.LOCALISATION;
                break;

              case footerController.FONCTIONS:
                //footerController.currentMenu = footerController.FONCTIONS;
                break;

              case footerController.TEMOINS:
                  footerController.currentMenu = footerController.TEMOINS;
                  break;

              case footerController.AUDIO_NAV:
                  //footerController.currentMenu = footerController.AUDIO_NAV;
                  break;

              case footerController.SCAN:
                  footerController.currentMenu = footerController.SCAN;
                  break;

              default:

            }

            preferences.setItemVehicle("lastMenu", footerController.currentMenu);

            $("#app-content").find("#footer").find("[data-footer-item]").removeClass("actif");
            $("#app-content").find("#footer").find("[data-footer-item='" + footerController.currentMenu + "']").addClass("actif");
        }
        else if ( categoryScreen.toLowerCase() == "details" )  {
            $("#app-content").find("#footer").find("[data-footer-item]").removeClass("actif");
            $("#app-content").find("#footer").find("[data-footer-item='" + footerController.currentMenu + "']").addClass("actif");
        }
        else {
            $("#app-content").find("#footer").find("[data-footer-item]").removeClass("actif");
        }
    }
    else{
        $("#app-content").find("#footer").find("[data-footer-item]").removeClass("actif");
    }
}

footerController.runScan = function() {
    if ( pleinEcran.etat !== pleinEcran.etatpleinecran ) {
        tagManagerController.tagGoogleAnalyticsAction({"eventCategory": "Footer", "eventAction": "Redirection::Internal", "eventLabel": "Scan", "virtualPageUrl": "/scan"});
        gvtController.runScan();
    }
}
